// src/utils/contractUtils.js
import Web3 from 'web3';
import { ethers } from 'ethers';

// Contract configuration
export const CONTRACT_ADDRESS = "0xa2ed1EA4C4826dBDF952BBc49f2338f3A9064ae5";
export const CONTRACT_ABI = [
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_poolId",
                "type": "uint256"
            }
        ],
        "name": "completePool",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_entryFee",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_maxEntriesPerUser",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_maxEntries",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_duration",
                "type": "uint256"
            },
            {
                "internalType": "uint16",
                "name": "_creatorFeePercent",
                "type": "uint16"
            },
            {
                "internalType": "uint16",
                "name": "_platformFeePercent",
                "type": "uint16"
            },
            {
                "internalType": "uint16",
                "name": "_gasFeePercent",
                "type": "uint16"
            }
        ],
        "name": "createPool",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_poolId",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_entries",
                "type": "uint256"
            }
        ],
        "name": "enterPool",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [],
        "stateMutability": "nonpayable",
        "type": "constructor"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "poolId",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "address",
                "name": "participant",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "entries",
                "type": "uint256"
            }
        ],
        "name": "EntryPurchased",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "poolId",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "address[]",
                "name": "winners",
                "type": "address[]"
            },
            {
                "indexed": false,
                "internalType": "uint256[]",
                "name": "prizes",
                "type": "uint256[]"
            }
        ],
        "name": "PoolCompleted",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "poolId",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "address",
                "name": "creator",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "entryFee",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "maxEntries",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "duration",
                "type": "uint256"
            }
        ],
        "name": "PoolCreated",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "_newOwner",
                "type": "address"
            }
        ],
        "name": "transferPlatformOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "withdrawGasFees",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_poolId",
                "type": "uint256"
            }
        ],
        "name": "getPoolInfo",
        "outputs": [
            {
                "internalType": "address",
                "name": "creator",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "entryFee",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "maxEntriesPerUser",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "maxEntries",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "totalEntries",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "creationTime",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "duration",
                "type": "uint256"
            },
            {
                "internalType": "bool",
                "name": "completed",
                "type": "bool"
            },
            {
                "internalType": "uint16",
                "name": "creatorFeePercent",
                "type": "uint16"
            },
            {
                "internalType": "uint16",
                "name": "platformFeePercent",
                "type": "uint16"
            },
            {
                "internalType": "uint16",
                "name": "gasFeePercent",
                "type": "uint16"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_poolId",
                "type": "uint256"
            }
        ],
        "name": "getPoolWinners",
        "outputs": [
            {
                "internalType": "address[]",
                "name": "",
                "type": "address[]"
            },
            {
                "internalType": "uint256[]",
                "name": "",
                "type": "uint256[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_poolId",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "_user",
                "type": "address"
            }
        ],
        "name": "getUserEntries",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "platformOwner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "poolCount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "pools",
        "outputs": [
            {
                "internalType": "address",
                "name": "creator",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "entryFee",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "maxEntriesPerUser",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "maxEntries",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "totalEntries",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "creationTime",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "duration",
                "type": "uint256"
            },
            {
                "internalType": "bool",
                "name": "completed",
                "type": "bool"
            },
            {
                "internalType": "uint16",
                "name": "creatorFeePercent",
                "type": "uint16"
            },
            {
                "internalType": "uint16",
                "name": "platformFeePercent",
                "type": "uint16"
            },
            {
                "internalType": "uint16",
                "name": "gasFeePercent",
                "type": "uint16"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
];

// Initialize web3 contract
export const initializeWeb3 = () => {
  if (window.ethereum) {
    const web3 = new Web3(window.ethereum);
    const contract = new web3.eth.Contract(CONTRACT_ABI, CONTRACT_ADDRESS);
    
    return { web3, contract };
  }
  return { web3: null, contract: null };
};

// Format address for display
export const formatAddress = (address) => {
  if (!address) return "";
  return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
};

// Format time remaining
export const formatTimeRemaining = (creationTime, duration) => {
    if (!creationTime || !duration) return "Until filled";
    if (duration === "0" || duration === 0) return "Until filled";
    
    const endTime = parseInt(creationTime) + parseInt(duration);
    const now = Math.floor(Date.now() / 1000);
    const timeRemaining = endTime - now;
    
    if (timeRemaining <= 0) return "Awaiting completion";
    
    const hours = Math.floor(timeRemaining / 3600);
    const minutes = Math.floor((timeRemaining % 3600) / 60);
    
    return `${hours}h ${minutes}m`;
  };

// Generate simple pool name based on ID
export const generatePoolName = (poolId) => {
  return `Pool #${poolId}`;
};

// Calculate pool prize
export const calculatePoolPrize = (entryFee, maxEntries, prizePercent) => {
    // Convertir a números y validar
    const fee = parseFloat(entryFee) || 0;
    const entries = parseInt(maxEntries) || 0;
    const percent = parseFloat(prizePercent) || 90; // 90% por defecto si no se especifica
    
    // Calcular premio
    const totalPool = fee * entries;
    return (totalPool * (percent / 100)).toFixed(3);
  };

// Listen to contract events
export const setupContractListeners = (contract, callbacks) => {
  if (!contract) return null;
  
  const listeners = {
    poolCreated: contract.events.PoolCreated()
      .on('data', event => {
        console.log('New pool created:', event.returnValues);
        if (callbacks.onPoolCreated) callbacks.onPoolCreated(event);
      })
      .on('error', error => console.error('Error in PoolCreated event:', error)),
      
    entryPurchased: contract.events.EntryPurchased()
      .on('data', event => {
        console.log('New entry purchased:', event.returnValues);
        if (callbacks.onEntryPurchased) callbacks.onEntryPurchased(event);
      })
      .on('error', error => console.error('Error in EntryPurchased event:', error)),
      
    poolCompleted: contract.events.PoolCompleted()
      .on('data', event => {
        console.log('Pool completed:', event.returnValues);
        if (callbacks.onPoolCompleted) callbacks.onPoolCompleted(event);
      })
      .on('error', error => console.error('Error in PoolCompleted event:', error))
  };
  
  return listeners;
};

// Helper to clean up event listeners
export const cleanupContractListeners = (listeners) => {
  if (!listeners) return;
  
  Object.values(listeners).forEach(listener => {
    if (listener && listener.unsubscribe) {
      listener.unsubscribe();
    }
  });
};